export default __webpack_public_path__ + "static/media/icon-upload.d41ba420.svg";